<template>
    <div class="keyboardContainer">
        <p class="input">{{ maskedInput }}<span class="cursor"></span></p>
        <div class="keyboard">
            
            <!-- ALPHABET -->
            <div class="alphabet" v-if="!useNumericKeys">
                <div class="row toprow">
                    <span 
                        v-for="key in keyboard.toprow" @click="keyPress(key)" class="key" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
                </div>
                <div class="row middlerow">
                    <span v-for="key in keyboard.middlerow" @click="keyPress(key)" class="key" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
                </div>
                <div class="row bottomrow">
                    <span class="key shiftkey" @click="keyPress('shift')" v-bind:class="{ green: useUppercase == 'once', red: useUppercase == 'always' }">&uarr;</span>
                    <span v-for="key in keyboard.bottomrow" class="key" @click="keyPress(key)" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
                    <span class="key backspacekey" @click="keyPress('backspace')">&larr;</span>
                </div>
                <div class="row bottomestrow">
                    <span class="key numToggle" @click="keyPress('123')">123</span>
                    <span class="key spacekey" @click="keyPress(' ')" v-bind:class="{ grey: charLimit }">&nbsp;</span>
                </div>
            </div>
            
            <!-- NUMERIC -->
            <div class="numeric" v-if="useNumericKeys">
                <div class="row toprow">
                    <span 
                        v-for="key in keyboard.toprowNum" @click="keyPress(key)" class="key" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
                </div>
                <div class="row middlerow">
                    <span v-for="key in keyboard.middlerowNum" @click="keyPress(key)" class="key" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
                </div>
                <div class="row bottomrow">
                    <span v-for="key in keyboard.bottomrowNum" class="key" @click="keyPress(key)" v-bind:class="{ uppercase: useUppercase != 'no', grey: charLimit }">{{ key }}</span>
                    
                </div>
                <div class="row bottomestrow">
                    <span class="key numToggle" @click="keyPress('abc')" v-if="!numericOnly">abc</span>
                    <span class="spacerKey" v-if="numericOnly">&nbsp;</span>
                    <span class="key" @click="keyPress('0')" v-bind:class="{ grey: charLimit }">0</span>
                    <span class="key backspacekey" @click="keyPress('backspace')">&larr;</span>
                </div>
            </div>


        </div>
        <div class="okbutton" @click="submitInput()">
            <font-awesome-icon icon="check" />
        </div>
    </div>

    

</template>

<script>

export default {

    name: 'Keyboard',

    data() {
        return {
            keyboard: {
                toprow: ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
                middlerow: ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
                bottomrow: ['z', 'x', 'c', 'v', 'b', 'n', 'm'],
                toprowNum: ['7', '8', '9'],
                middlerowNum: ['4', '5', '6'],
                bottomrowNum: ['1', '2', '3'],
            },
            useUppercase: 'once',
            input: '',
            useNumericKeys: false
        }
    },
    
    props: ['numericOnly', 'inputMasked'],

    computed: {
        charLimit() {
            return this.input.length >= 12;
        },

        maskedInput() {
            if (this.inputMasked) {
                let maskedInput = '';
                for (let i = 0; i < this.input.length; i++) {
                    maskedInput += '*';
                }
                return maskedInput;
            }
            return this.input;
        }
    },

    methods: {
        keyPress(key) {
            if (key == 'shift') {
                this.toggleShift();
            } else if (key == 'backspace') {
                this.input = this.input.slice(0, this.input.length - 1);
            } else if (key == '123') {
                console.log('numeric on')
                this.useNumericKeys = true;
            } else if (key == 'abc') {
                console.log('numeric off')
                this.useNumericKeys = false;
            } else {
                if (this.input.length < 12) {
                    if (this.useUppercase == 'once' || this.useUppercase == 'always') {
                        key = key.toUpperCase();
                        if (this.useUppercase == 'once') {
                            this.useUppercase = 'no';
                        }
                    }
                    this.input += key;
                }
            }

            if (key == " " && this.useUppercase != 'always') {
                this.toggleShift();
            }
        },

        toggleShift() {
            if (this.useUppercase == 'no') {
                this.useUppercase = 'once';
            } else if (this.useUppercase == 'once') {
                this.useUppercase = 'always';
            } else if (this.useUppercase == 'always') {
                this.useUppercase = 'no';
            }
        },

        submitInput() {
            if (this.input.length > 0) {
                this.$emit('submitInput', this.input);
            }
        },

    },

    mounted() {
        if (this.numericOnly) {
            this.useNumericKeys = true;
        }
    }

}
</script>


<style scoped>

    

    * {
    
        box-sizing: border-box;
    }

    .keyboardContainer {
        position: absolute;
        width: 800px;
        height: 390px;
        top: 90px;
        /*background: rgba(0,0,0,0.7);*/
        background: #eee;
        z-index: 11;
        /*color: white;*/
        /*display: relative;*/

    }

    .input {
        font-size: 32px;
        text-align: center;
        width: 400px;
        border: 1px solid #ccc;
        margin: 20px auto;
        padding: 5px 5px 10px;
        background: #fff;
        height: 60px;
        /*box-shadow: 1px 1px 3px rgba(0,0,0,0.24);*/
    }

    .cursor {
        color: #222;
    }

    .keyboard {
        position: absolute;
        bottom: 0px;
        /*display: flex;*/
        /*flex-wrap: wrap;*/
        text-align: center;
        width: 100%;
    }

    .row {
        /*height: 100px;*/
        margin-bottom: 10px;
    }

    .key {
        display: inline-block;
        /*border: 1px solid #ccc;*/
        border-top: 1px solid rgba(0,0,0,0.12);
        border-left: 1px solid rgba(0,0,0,0.12);

        font-size: 28px;
        padding: 8px 0px 0;
        width: 60px;
        height: 60px;
        text-align: center;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.48);
        margin-left: 10px;
        border-radius: 10px;
        cursor: pointer;
        user-select: none;
        background: #fff;


    }

    .spacerKey {
        display: inline-block;
        width: 100px;
        height: 60px;
        margin-left: 10px;
        padding: 8px 0px 0;
    }

    .key.numToggle {
        width: 100px;
    }
    .toprow {

    }
    .middlerow {
        /*margin-left: 30px;*/
    }
    .bottomrow {
        /*margin-left: -60px;*/
    }
    .bottomestrow {
        /*margin-left: 210px;*/
    }
    .key.spacekey {
        width: 340px;
        /*margin-left: 200px;*/
    }

    .key.shiftkey {
        width: 100px;
    }
    .key.backspacekey {
        width: 100px;
    }

    .okbutton {
        position: absolute;
        /*right: 15px;*/
        right: 90px;
        /*bottom: 15px;*/
        bottom: 310px;
        display: inline-block;
        border: 1px solid #ccc;
        font-size: 28px;
        padding: 8px 0px 0;
        width: 100px;
        height: 60px;
        text-align: center;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        margin-left: 10px;
        border-radius: 10px;
        background: #fff;
        cursor: pointer;
        user-select: none;

    }

    .uppercase {
        text-transform: uppercase;
    }

    .green {
        background: #efe;
        border: 1px solid #0f0;
    }
    .red {
        background: #fee;
        border: 1px solid #f00;
    }

    .grey {
        background: #eee;
        /*border: 1px solid #aaa;*/
    }
</style>
